<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>查排名</el-breadcrumb-item>
        <el-breadcrumb-item>成绩审核</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">成绩审核</h2>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="院校名称"
                      prop="name">
          <el-input v-model="query.college_keyword"
                    placeholder="输入院校名称"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="学院名称"
                      prop="name">
          <el-input v-model="query.academy_keyword"
                    placeholder="输入学院名称"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="专业名称"
                      prop="name">
          <el-input v-model="query.major_keyword"
                    placeholder="输入专业名称"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="年份"
                      prop="year">
          <el-select v-model="adjust_year"
                     placeholder="请选择"
                     @input="fetchList(true)">
            <el-option v-for="item in filter.years"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="审核状态">
          <el-select clearable
                     v-model="query.check_statuses"
                     placeholder="请选择"
                     @input="fetchList(true)">
            <el-option v-for="item in filter.checkStatus"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系统审核状态">
          <el-select clearable
                     v-model="query.sys_check_statuses"
                     placeholder="请选择"
                     @input="fetchList(true)">
            <el-option v-for="item in filter.sysCheckStatus"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="用户名称"
                      prop="name">
          <el-input v-model="query.user_keyword"
                    placeholder="名字/手机号"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>

        <el-form-item label="总分段起点"
                      prop="name">
          <el-input type="number"
                    v-model="query.start_total_score"
                    placeholder="总分段起点"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="总分段终点"
                      prop="name">
          <el-input type="number"
                    v-model="query.end_total_score"
                    placeholder="总分段终点"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="values-header"
           style="display:flex;  justify-content: space-between;margin-bottom:10px">
        <p class="title">审核列表</p>
        <!-- <el-button type="primary"
                   style="height:40px"
                   @click="oneClick()">一键核验</el-button> -->

        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>

            <el-radio-group v-model="query.check_statuses"
                            @change="fetchList(true)">
              <el-radio-button v-for="(item, index) in filter.checkStatus"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           width="70"
                           label="ID"
                           align="center">
          </el-table-column>
          <el-table-column label="提交时间"
                           align="center"
                           width="150"
                           show-overflow-tooltip>

            <template slot-scope="scope">
              {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="user_name"
                           label="姓名"
                           align="center"
                           width="90"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="报录信息"
                           align="center"
                           width="200">
            <template slot-scope="scope">
              {{
      scope.row.college_name || scope.row.college_name || 
      scope.row.major_code || scope.row.major_code 
        ? `${scope.row.college_name || '--'}/${scope.row.academy_name || '--'}/${scope.row.major_code || '--'}${scope.row.major_name || '--'}`
        : '--'
    }}
            </template>
          </el-table-column>
          <el-table-column label="科目"
                           align="center"
                           width="300"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateSubject(scope.row.subjects) }}
            </template>
          </el-table-column>
          <el-table-column label="总分"
                           align="center"
                           width="80"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.total_score }}分
            </template>
          </el-table-column>
          <el-table-column label="成绩信息"
                           align="center"
                           width="120"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <!-- 判断所有成绩字段是否为空 -->
              <span v-if="!scope.row.politics_score && 
                !scope.row.language_score && 
                !scope.row.profession1_score && 
                !scope.row.profession2_socre">
                --
              </span>
              <span v-else>
                {{ scope.row.politics_score?scope.row.politics_score:'--' }}/{{ scope.row.language_score?scope.row.language_score:'--'}}/{{scope.row.profession1_score?scope.row.profession1_score:'--'}}/{{scope.row.profession2_socre?scope.row.profession2_socre:'--'}}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="os"
                           label="科目1成绩"
                           align="center"
                           width="80"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.politics_score
                  ? `${scope.row.politics_score}分`
                  : "无"
              }}
            </template>
          </el-table-column> -->

          <!-- <el-table-column prop="os"
                           label="科目2成绩"
                           align="center"
                           width="80"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.language_score
                  ? `${scope.row.language_score}分`
                  : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="os"
                           label="科目3成绩"
                           align="center"
                           width="80"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.profession1_score
                  ? `${scope.row.profession1_score}分`
                  : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="os"
                           label="科目4成绩"
                           align="center"
                           width="80"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.profession2_socre
                  ? `${scope.row.profession2_socre}分`
                  : "无"
              }}
            </template>
          </el-table-column> -->
          <el-table-column label="成绩截图"
                           align="center">
            <template slot-scope="scope">
              <el-image v-if="scope.row.picture_url"
                        style="width: 60px; height: 60px"
                        :src="scope.row.picture_url"
                        :preview-src-list="[scope.row.picture_url]">
              </el-image>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column label="审核状态"
                           align="center"
                           width="150"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateStatus(scope.row.check_status) }}
            </template>
          </el-table-column>
          <el-table-column label="系统审核状态"
                           align="center"
                           width="150"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateStatus(scope.row.sys_check_status) }}
            </template>
          </el-table-column>
          <el-table-column prop="refuse_reason"
                           label="拒绝理由"
                           align="center"
                           width="90"
                           show-overflow-tooltip
                           v-if="query.check_statuses=='2'">
          </el-table-column>
          <el-table-column label="更新时间"
                           align="center"
                           width="150"
                           show-overflow-tooltip>

            <template slot-scope="scope">
              {{
                scope.row.update_time
                  ? $moment(scope.row.update_time).format("YYYY-MM-DD HH:mm")
                  : ""
              }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="被质疑"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.question_count }}次</span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="150">
            <template slot-scope="scope">

              <el-link type="primary"
                       :underline="false"
                       v-if="scope.row.check_status == 0 && !scope.row.picture_url"
                       @click="rank(scope.row.id, 1, 1)">未核验</el-link>
              <span @mouseover="mouseover(scope.row)"
                    @mouseout="mouseout"
                    v-else-if="scope.row.check_status == 0&& scope.row.picture_url">
                <el-link slot="reference"
                         type="primary"
                         :underline="false"
                         @click="rank(scope.row.id, 1, 1)">
                  待核验
                </el-link>
                <div style="position: fixed; top: 10%; left: 10%;  background: rgba(0, 0, 0, 0.85); padding: 20px;"
                     v-show="imgShow">
                  <div style="display: flex; align-items: center;">
                    <img :src="picture_url"
                         alt=""
                         style="width: 600px; height: 850px; object-fit: contain" />
                    <div class="score-info-card">
                      <div class="score-info-title">成绩详情</div>
                      <div class="score-item">
                        <span class="score-label">科目一成绩:</span>
                        <span class="score-value ">{{scoreInfo.politics_score || '-'}}</span>
                      </div>
                      <div class="score-item">
                        <span class="score-label">科目二成绩:</span>
                        <span class="score-value ">{{scoreInfo.language_score || '-'}}</span>
                      </div>
                      <div class="score-item">
                        <span class="score-label">科目三成绩:</span>
                        <span class="score-value ">{{scoreInfo.profession1_score || '-'}}</span>
                      </div>
                      <div class="score-item">
                        <span class="score-label">科目四成绩:</span>
                        <span class="score-value ">{{scoreInfo.profession2_socre || '-'}}</span>
                      </div>
                      <div class="score-total">
                        <span class="score-label">总分:</span>
                        <span class="score-value">{{scoreInfo.total_score || '-'}}</span>
                      </div>
                    </div>
                  </div>

                </div>
              </span>

              <el-link type="success"
                       :underline="false"
                       v-else-if="scope.row.check_status == 1"
                       :disabled="true">已核验</el-link>
              <el-link type="danger"
                       :underline="false"
                       v-else>核验错误</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handelCheck(scope.row)"
                       :disabled="scope.row.check_status!='0'">编辑</el-link>
              <!-- <el-link type="primary"
                       :underline="false"
                       :disabled="!scope.row.picture_url"
                       @click="rank(scope.row.id, 2)">删图</el-link> -->

              <el-link type="danger"
                       @click="handelDelete(scope.row.id)"
                       :underline="false"
                       :disabled="scope.row.year == 2022">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="position: relative;">
        <div class="footer">
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handlePageChange"></el-pagination>

        </div>
        <div class="btn-box">
          <el-button type="primary"
                     style="margin-left: 200px;"
                     @click="checkAll()">全部通过</el-button>
        </div>

      </div>

    </div>
    <ScoreCheckDialog :visible.sync="dialogVisible"
                      :data-form="formData"
                      :id_array="idArray"
                      @confirm="handleConfirm"
                      @close="handleClose" />
  </div>
</template>

<script>
import {
  rankuserlist,
  rankdelete,
  rankput,
  adjustConfigList,
  allScoreCheck,
  ScoreCheck,
} from '@/api/rank'
import ScoreCheckDialog from '@/components/dialog/adjust/ScoreCheckDialog.vue'

export default {
  components: { ScoreCheckDialog },
  data() {
    return {
      formData: {},
      imgShow: false,
      picture_url: '',
      scoreInfo: {},
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        // year: 2025,
        check_statuses: '0',
      },
      pageTotal: 10,
      results: [],
      filter: {
        checkStatus: [
          {
            label: '全部',
            value: '4',
          },
          {
            label: '待审核(有图)',
            value: '0',
          },
          {
            label: '待审核(无图)',
            value: '3',
          },
          {
            label: '已审核',
            value: '1',
          },
          {
            label: '已驳回',
            value: '2',
          },
        ],
        sysCheckStatus: [
          {
            label: '待审核',
            value: '0',
          },
          {
            label: '已审核',
            value: '1',
          },
          {
            label: '已驳回',
            value: '2',
          },
        ],
        years: [
          {
            label: '2027年',
            value: 2027,
          },
          {
            label: '2026年',
            value: 2026,
          },
          {
            label: '2025年',
            value: 2025,
          },
          {
            label: '2024年',
            value: 2024,
          },
          {
            label: '2023年',
            value: 2023,
          },
        ],
      },
      loading: false,
      adjust_year: '',
      idArray: [],
      dialogVisible: false,
    }
  },
  created() {
    this.getYear()
  },
  methods: {
    handelCheck(item) {
      this.idArray = this.results.map((item) => item.id)
      this.formData = item
      this.dialogVisible = true
    },
    handleConfirm() {
      console.log('tijiaochenggong')
      this.dialogVisible = false
      this.fetchList()
    },
    handleClose() {
      this.dialogVisible = false
    },
    formateStatus(status) {
      if (status == '0') {
        return '待审核'
      } else if (status == '1') {
        return '已通过'
      } else if (status == '2') {
        return '已驳回'
      }
    },
    getYear() {
      adjustConfigList().then((res) => {
        this.adjust_year = res.adjust_year
        this.fetchList()
      })
    },
    mouseover(row) {
      this.imgShow = true
      this.picture_url = row.picture_url
      this.scoreInfo = row
    },

    // oneClick() {
    //   this.imgShow = true
    //   let cycleId = 0
    //   const intervalId = setInterval(() => {
    //     if (cycleId < this.results.length) {
    //       this.picture_url = this.results[cycleId].picture_url
    //       let data = {
    //         id: this.results[cycleId].id,
    //         check_status: 1,
    //       }
    //       rankput(data).then((res) => {})
    //       cycleId++ // 处理下一条数据
    //     } else {
    //       this.$message({
    //         type: 'success',
    //         message: '修改成功!',
    //       })
    //       clearInterval(intervalId) // 审核完成后清除定时器
    //       this.imgShow = false // 恢复审核状态
    //       this.picture_url = ''
    //       this.fetchList()
    //     }
    //   }, 1000)
    // },
    checkAll() {
      let idarr = this.results.map((item) => item.id)
      console.log('当前页id数组')
      let obj = {
        arr_score_id: idarr,
        check_status: 1,
      }
      allScoreCheck(obj).then((res) => {
        this.fetchList()
        this.$message({
          type: 'success',
          message: '批量审核通过成功!',
        })
      })
    },

    mouseout() {
      this.imgShow = false
      this.picture_url = ''
      this.scoreInfo = {}
    },
    rank(id, type, state) {
      let obj = {
        score_id: id,
      }
      obj.check_status = state
      ScoreCheck(obj).then((res) => {
        this.mouseout()
        this.fetchList()
        this.$message({
          type: 'success',
          message: '修改成功!',
        })
      })
    },

    // rank(id, type, state) {
    //   let data = {
    //     id: id,
    //   }
    //   let text = ''
    //   if (type == 1) {
    //     data.check_status = state
    //     if (state == 1) {
    //       this.mouseout()
    //       text = '“未核验”修改为“已核验”'
    //     } else {
    //       text = '“已核验”修改为“未核验”'
    //     }
    //   } else {
    //     data.picture_url = null
    //     text = '删除成绩截图'
    //   }
    //   if (type != 2) {
    //     this.upRankData(data)
    //     return
    //   }
    //   this.$confirm(`此操作将${text}, 是否继续?`, '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //   })
    //     .then(() => {
    //       this.upRankData(data)
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消修改',
    //       })
    //     })
    // },
    upRankData(data) {
      rankput(data).then((res) => {
        this.fetchList()
        this.$message({
          type: 'success',
          message: '修改成功!',
        })
      })
    },

    // 客户端列表请求
    fetchList(isReset = false) {
      this.loading = true
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      let data = {}
      if (this.query.check_statuses == 0) {
        data = {
          is_picture_url: 1,
        }
      } else if (this.query.check_statuses == 3) {
        data = {
          is_picture_url: 0,
          check_statuses: 0,
        }
      } else if (this.query.check_statuses == 4) {
        data = { check_statuses: '' }
      }
      let yy = {
        ...this.query,
        ...data,
      }
      yy.year = this.adjust_year
      rankuserlist(yy).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
        this.loading = false
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()

      this.fetchList()
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    formateSubject(subjects) {
      let arr = JSON.parse(subjects)
      return arr[0]
        .map((v) => {
          return `(${v.code})${v.name}`
        })
        .join('+')
    },
    handelDelete(id) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          rankdelete({ id: id }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchList()
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped lang="less">
.btn-box {
  position: absolute;
  top: 0;
  right: 0;
}
/* 成绩信息卡片 */
.score-info-card {
  background-color: #f5f7fa;
  border-radius: 8px;
  padding: 30px 25px;
  min-width: 350px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* 成绩标题 */
.score-info-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 25px;
  text-align: center;
  border-bottom: 2px solid #409eff;
  padding-bottom: 10px;
}
.score-item {
  margin-bottom: 20px;
}

/* 成绩标签（科目名称） */
.score-label {
  font-size: 18px;
  color: #666;
  width: 120px;
  display: inline-block;
}

/* 成绩数值通用样式 */
.score-value {
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 1px;
}
/deep/.el-link {
  margin: 0 4px;
}
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
  .el-link {
    font-style: 12px;
  }
}
</style>
